import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateCalculatedFunds } from '../../../store/actionCreators/fundsActions';

export const useProfileData = () => {
  const dispatch = useDispatch();
  const { userData, userSettings, isUpdating } = useSelector(state => state.profile);
  const brokerageMessage = useSelector(state => state.brokerage.brokerageData);

  const [showWelcome, setShowWelcome] = useState(true);
  const [referralCopied, setReferralCopied] = useState(false);

  useEffect(() => {
    const hasVisitedProfile = localStorage.getItem('hasVisitedProfile');
    if (hasVisitedProfile) {
      setShowWelcome(false);
    } else {
      const timer = setTimeout(() => {
        setShowWelcome(false);
        localStorage.setItem('hasVisitedProfile', 'true');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);
  
  useEffect(() => {
    dispatch(updateCalculatedFunds());
  }, [dispatch]);

  return {
    userData,
    userSettings,
    isUpdating,
    brokerageMessage,
    showWelcome,
    setShowWelcome,
    referralCopied,
    setReferralCopied,
  };
};

